module.exports = __webpack_public_path__ + "img/type1_bg_1.3f90896c.png";